import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-row text-12px mt-4 xxl:text-14px space-x-4 items-center"
}
const _hoisted_2 = { class: "p-field-checkbox mt-3 relative" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "49",
  height: "46",
  viewBox: "0 0 49 46",
  fill: "none"
}, [
  /*#__PURE__*/_createVNode("rect", {
    x: "1",
    y: "9.78418",
    width: "35.3711",
    height: "35.3711",
    fill: "white",
    stroke: "black"
  }),
  /*#__PURE__*/_createVNode("rect", {
    x: "15.0508",
    y: "9.78418",
    width: "7.26804",
    height: "35.3711",
    fill: "white",
    stroke: "black"
  }),
  /*#__PURE__*/_createVNode("rect", {
    width: "14.5749",
    height: "35.3711",
    transform: "matrix(0.797867 -0.602833 0 1 36.3711 9.78662)",
    fill: "white",
    stroke: "black"
  }),
  /*#__PURE__*/_createVNode("rect", {
    width: "4.85831",
    height: "35.3711",
    transform: "matrix(0.797867 -0.602833 0 1 40.7305 6.4917)",
    fill: "#B82025",
    stroke: "black"
  }),
  /*#__PURE__*/_createVNode("rect", {
    width: "14.5749",
    height: "7.23218",
    transform: "matrix(0.797867 -0.602833 0 1 36.3711 9.78662)",
    fill: "white",
    stroke: "black"
  }),
  /*#__PURE__*/_createVNode("rect", {
    width: "14.5749",
    height: "7.23218",
    transform: "matrix(0.797867 -0.602833 0 1 36.3711 37.9521)",
    fill: "white",
    stroke: "black"
  }),
  /*#__PURE__*/_createVNode("rect", {
    x: "27.9766",
    y: "13.3125",
    width: "4.84777",
    height: "32.3707",
    transform: "rotate(43.1142 27.9766 13.3125)",
    fill: "#B82025",
    stroke: "black"
  }),
  /*#__PURE__*/_createVNode("rect", {
    x: "32.0078",
    y: "36.2861",
    width: "4.84777",
    height: "32.3707",
    transform: "rotate(134.011 32.0078 36.2861)",
    fill: "#B82025",
    stroke: "black"
  }),
  /*#__PURE__*/_createVNode("rect", {
    x: "29.1016",
    y: "9.78418",
    width: "7.26804",
    height: "35.3711",
    fill: "white",
    stroke: "black"
  }),
  /*#__PURE__*/_createVNode("rect", {
    x: "1",
    y: "9.78418",
    width: "7.26804",
    height: "35.3711",
    fill: "white",
    stroke: "black"
  }),
  /*#__PURE__*/_createVNode("rect", {
    x: "1",
    y: "9.78418",
    width: "35.3711",
    height: "7.26804",
    fill: "white",
    stroke: "black"
  }),
  /*#__PURE__*/_createVNode("rect", {
    x: "1",
    y: "37.8872",
    width: "35.3711",
    height: "7.26804",
    fill: "white",
    stroke: "black"
  }),
  /*#__PURE__*/_createVNode("circle", {
    cx: "33.4653",
    cy: "12.6914",
    r: "1.10361",
    fill: "#B82025",
    stroke: "black",
    "stroke-width": "0.7"
  }),
  /*#__PURE__*/_createVNode("circle", {
    cx: "3.90673",
    cy: "12.6914",
    r: "1.10361",
    fill: "#B82025",
    stroke: "black",
    "stroke-width": "0.7"
  }),
  /*#__PURE__*/_createVNode("circle", {
    cx: "3.90673",
    cy: "42.248",
    r: "1.10361",
    fill: "#B82025",
    stroke: "black",
    "stroke-width": "0.7"
  }),
  /*#__PURE__*/_createVNode("circle", {
    cx: "33.4653",
    cy: "42.248",
    r: "1.10361",
    fill: "#B82025",
    stroke: "black",
    "stroke-width": "0.7"
  }),
  /*#__PURE__*/_createVNode("path", {
    d: "M12.7578 1.0625H47.8514L36.0933 9.88106H0.999735L12.7578 1.0625Z",
    fill: "white",
    stroke: "black",
    "stroke-width": "1.5",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createVNode("path", {
    d: "M8.88281 3.96973H43.9764L39.9709 6.97385H4.87731L8.88281 3.96973Z",
    fill: "#B82025",
    stroke: "black",
    "stroke-width": "1.5",
    "stroke-linejoin": "round"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!

  return _withDirectives((_openBlock(), _createBlock("div", null, [
    (_ctx.version === 'v1')
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode(_component_DataWrapper, {
            label: "Woodpacking",
            class: "w-1/2",
            optional: ""
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_2, [
                _createVNode(_component_Checkbox, {
                  id: "woodpacking",
                  binary: true,
                  modelValue: _ctx.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.value = $event)),
                  disabled: _ctx.isDisabled,
                  onChange: _ctx.setValue
                }, null, 8, ["modelValue", "disabled", "onChange"]),
                _createVNode("label", {
                  class: "ml-2 text-14px",
                  for: "woodpacking",
                  style: `${_ctx.isDisabled ? `color:#9e9e9e` : ''}`
                }, _toDisplayString(_ctx.$t("bookingShipment.column.woodPacking")), 5)
              ])
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode("div", {
            class: `${_ctx.isDisabled ? 'p-field-checkbox-grey' : 'p-field-checkbox'} mt-5 relative flex flex-row gap-x-2 items-center`
          }, [
            _hoisted_4,
            _createVNode(_component_Checkbox, {
              id: "woodpacking",
              binary: true,
              modelValue: _ctx.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.value = $event)),
              disabled: _ctx.isDisabled,
              onChange: _ctx.setValue
            }, null, 8, ["modelValue", "disabled", "onChange"]),
            _createVNode("label", {
              class: "ml-2 text-14px",
              for: "woodpacking",
              style: `${_ctx.isDisabled ? `color:#9e9e9e` : ''}`
            }, _toDisplayString(_ctx.$t("bookingShipment.column.woodPacking")), 5)
          ], 2)
        ]))
  ], 512)), [
    [_vShow, _ctx.isAllowWoodPacking && _ctx.permissionSchedule]
  ])
}